import React from "react";
import { withRouter } from "react-router-dom";
import { config } from "config";
import Grid from "components/common/Grid";
import Box from "components/common/Box";
import SignUpForm from "components/Auth/SignUpForm";
import SignUpAsidePanel from "components/Auth/SignUpAsidePanel";
import { validationHelper } from "helper/validation";
import { customerApis } from "stores/customer/customerApis";
import { customerConstants } from "stores/customer/customerConstants";
import { customerParsers } from "stores/customer/customerParsers";
import { localStore } from "stores/localStorage";
import { tracker } from "library/tracker";
import { pushNotification } from "library/pushNotification";
import Image from "components/common/Image";
import {
  captureAllInOneSignupParams,
  getAllInOneLoginUrl,
  parseAllInOneSignupParams,
} from "helper/allInOneSignupParams";

const otpRequestTimer = 30;

export class SignUpContainer extends React.Component {
  emailInterval = 0;
  mobileInterval = 0;

  constructor(props) {
    super(props);
    this.state = {
      formManage: {
        isRequestOtp: false,
        emailVerified: false,
        mobileVerified: false,
      },
      formData: {
        requestId: "",
        name: "",
        email: "",
        mobile: "",
        password: "",
        emailOTP: "",
        mobileOTP: "",
        loginType: "normal",
        deviceType: "Web",
      },
      formError: {
        name: "",
        email: "",
        mobile: "",
        password: "",
        emailOTP: "",
        mobileOTP: "",
      },
      emailResendTime: 0,
      mobileResendTime: 0,
      isLoading: false,
    };
  }

  componentDidMount() {
    captureAllInOneSignupParams();
    this.setIntercomPosition();
  }

  componentWillUnmount() {
    clearInterval(this.emailInterval);
    clearInterval(this.mobileInterval);
  }

  setIntercomPosition = () => {
    let intercomElem =
      document.getElementsByClassName("intercom-launcher")[0] ||
      document.getElementsByClassName("intercom-launcher-frame")[0] ||
      document.getElementsByClassName("intercom-lightweight-app-launcher")[0];

    if (!intercomElem) {
      console.log("intercom element not found");
    } else {
      intercomElem.classList.add("intercom-launcher-noTab");
      intercomElem.classList.remove("intercom-launcher-hasTab");
    }
  };

  handleInputChange = (name, value) => {
    if (name === "mobile" && isNaN(value)) return;
    if (name === "name") value = value ? value.trimStart() : "";

    this.setState(
      ({ formData }) => {
        formData[name] = value;
        return { formData };
      },
      () => {
        const { formData } = this.state;
        if (name === "emailOTP" && value.length === 6) {
          tracker.registration.regEnterEmailOtp({
            app_reg_id: formData.requestId,
          });
        }
        if (name === "mobileOTP" && value.length === 6) {
          tracker.registration.regEnterMobileOtp({
            app_reg_id: formData.requestId,
          });
        }
      },
    );
  };

  handleValidation = () => {
    const { formData } = this.state;
    const formError = {
      name: validationHelper.name(formData.name).message,
      email: validationHelper.email(formData.email).message,
      mobile: validationHelper.mobile(formData.mobile).message,
      password: "",
      emailOTP: "",
      mobileOTP: "",
    };

    this.setState({ formError });
    return !formError.name && !formError.email && !formError.mobile;
  };

  handleRequestOtp = async (product) => {
    const { formData, formManage } = this.state;

    // Ask push permission on signup Continue click.
    await pushNotification.ensurePermission({ openSettingsIfDenied: true });

    tracker.registration.regRequestOtp({
      platform: config.platform,
      deviceId: this.props.deviceId,
      name: formData.name,
    });
    const queryParams = new URLSearchParams(window.location.search);
    const getIsBroker = queryParams.get("isBroker");
    const ref = queryParams.get("ref");

    if (!this.handleValidation()) return;

    this.setState({ isLoading: true });

    try {
      const allInOneParams = captureAllInOneSignupParams();
      const isAllInOne =
        allInOneParams.isAllInOne ||
        product === "ALL-IN-ONE" ||
        product === customerConstants.SOURCE_TYPE.ALL_IN_ONE;

      const res = await customerApis.initSignUp({
        deviceId: this.props.deviceId,
        deviceType: formData.deviceType,
        mobileNumber: formData.mobile,
        email: formData.email,
        name: formData.name,
        productCode: isAllInOne ? null : product,
        isBroker: getIsBroker ? getIsBroker : null,
        sourceType: isAllInOne ? customerConstants.SOURCE_TYPE.ALL_IN_ONE : null,
        ref: ref ? ref : null,
      });

      const parsedRes = customerParsers.requestOtp(res);
      if (parsedRes?.requestId) {
        await this.submitCampaignData({ email: formData.email });
        tracker.registration.regRequestOtpSuccess({
          app_reg_id: parsedRes.requestId,
          platform: config.platform,
          deviceId: this.props.deviceId,
          name: formData.name,
        });

        this.setState(
          {
            formData: { ...formData, requestId: parsedRes.requestId },
            formManage: { ...formManage, isRequestOtp: true },
          },
          this.mobileResendTimer,
        );
      }
    } catch (error) {
      tracker.registration.regRequestOtpError({
        app_reg_id: formData.requestId,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleFormSubmit = async (product) => {
    const { formData } = this.state;
    tracker.registration.signUp({
      app_reg_id: formData.requestId,
    });

    if (!this.handleValidation()) return;

    this.setState({ isLoading: true });

    try {
      const gioLoc = await localStore.getGeolocation();
      const res = await customerApis.completeSignup({
        deviceId: this.props.deviceId,
        deviceType: config.platform,
        requestId: formData.requestId,
        otp: formData.mobileOTP,
        signupType: "normal",
        latitude: gioLoc?.latitude || null,
        longitude: gioLoc?.longitude || null,
        // productCode: product ? product : null,
      });

      const result = customerParsers.login(res);

      tracker.registration.signUpSuccess({
        name: formData.name,
        loginType: formData.loginType,
        deviceId: this.props.deviceId,
        deviceType: config.platform,
        customerId: result.customerId,
      });

      localStore.setToken(result.token);
      localStore.setLegacyToken(result.legacyToken);

      result.lastActiveProduct &&
        localStore.setActiveProduct(result.lastActiveProduct);

      this.props.updateOnestockOnboardingDataAction(
        result.onestockOnboardingData,
      );
      this.props.updateOnboardingDataAction(result.onboardingData);
      this.props.updateRMSOnboardingDataAction(result.rmsOnboardingData);
      this.props.updatePrimeOnboardingDataAction(result.primeOnboardingData);
      this.props.updateSentimentTrackerOnboardingDataAction(
        result.sentimentTrackerOnboardingData,
      );
      this.props.updatePHCOnboardingDataAction(result.phcOnboardingData);

      const { pan, dob, aadharNumber } = result;
      if (pan || dob || aadharNumber) {
        this.props.updateOnboardingDataAction({
          pan,
          dateOfBirth: dob,
          aadharNumber,
        });
        this.props.updateRMSOnboardingDataAction({
          panNumber: pan,
          dateOfBirth: dob,
          aadharNumber,
        });
        this.props.updateOnestockOnboardingDataAction({
          panNumber: pan,
          dateOfBirth: dob,
          aadharNumber,
        });
        this.props.updatePrimeOnboardingDataAction({
          panNumber: pan,
          dateOfBirth: dob,
          aadharNumber,
        });
        this.props.updateSentimentTrackerOnboardingDataAction({
          panNumber: pan,
          dateOfBirth: dob,
          aadharNumber,
        });
        this.props.updatePHCOnboardingDataAction({
          panNumber: pan,
          dateOfBirth: dob,
          aadharNumber,
        });
      }

      this.props.updateAuthDataAction(result);
      this.props.updateAuthStatus(true);

      if (result.sourceType === customerConstants.SOURCE_TYPE.ALL_IN_ONE) {
        this.props.history.push("/all-in-one");
      }
    } catch (e) {
      tracker.registration.signUpError({
        user_id: formData.requestId,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  submitCampaignData = async ({ email }) => {
    const {
      utm_source,
      utm_campaign,
      utm_coupon,
      utm_product,
      utm_lead_id,
      restEventData = {},
    } = localStore.getAppsflyerData() || {};

    if (!utm_source || !utm_campaign) return;

    await customerApis.submitCampaignData({
      email,
      trackingInfo: {
        utm_source,
        utm_campaign,
        utm_coupon,
        utm_product,
        utm_lead_id,
        raw_json: { ...restEventData },
      },
    });
    localStore.resetAppsflyerData();
  };

  verifyOtp = async (type) => {
    if (!["email", "mobile"].includes(type)) return;

    const { formData, formManage } = this.state;
    this.setState({ isLoading: true });

    try {
      await customerApis.verifyOtp({
        requestId: formData.requestId,
        userName: formData.name,
        otp: type === "email" ? formData.emailOTP : formData.mobileOTP,
        type,
      });

      const newManage = { ...formManage };

      if (type === "email") {
        tracker.registration.regEnterEmailOtpSuccess({
          app_reg_id: formData.requestId,
        });
        newManage.emailVerified = true;
      }

      if (type === "mobile") {
        tracker.registration.regEnterMobileOtpSuccess({
          app_reg_id: formData.requestId,
        });
        newManage.mobileVerified = true;
      }

      this.setState({ formManage: newManage });
    } catch (e) {
      tracker.registration.regEnterEmailOtpError({
        app_reg_id: formData.requestId,
        error_msg: e.message,
      });
      tracker.registration.regEnterMobileOtpFailed({
        app_reg_id: formData.requestId,
        error_msg: e.message,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  emailResendTimer = () => {
    if (this.state.emailResendTime > 0) return;
    this.setState({ emailResendTime: otpRequestTimer });

    this.emailInterval = setInterval(() => {
      this.setState(({ emailResendTime }) => {
        const time = emailResendTime - 1;
        if (time === 0) clearInterval(this.emailInterval);
        return { emailResendTime: time };
      });
    }, 1000);
  };

  mobileResendTimer = () => {
    if (this.state.mobileResendTime > 0) return;
    this.setState({ mobileResendTime: otpRequestTimer });

    this.mobileInterval = setInterval(() => {
      this.setState(({ mobileResendTime }) => {
        const time = mobileResendTime - 1;
        if (time === 0) clearInterval(this.mobileInterval);
        return { mobileResendTime: time };
      });
    }, 1000);
  };

  handleResendOtp = async (type) => {
    const { formData } = this.state;
    if (!["email", "mobile"].includes(type) || !formData.requestId) return;

    this.setState({ isLoading: true });
    try {
      const res = await customerApis.requestSignupOTP({
        requestId: formData.requestId,
        requestType: type,
      });

      const parsedRes = customerParsers.requestOtp(res);

      this.setState(
        {
          formData: { ...formData, requestId: parsedRes.requestId },
        },
        () => {
          type === "email" ? this.emailResendTimer() : this.mobileResendTimer();
        },
      );
    } catch {
      // optionally log error
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleBackToStep1 = () => {
    clearInterval(this.mobileInterval);
    this.setState(({ formData, formManage }) => ({
      formManage: {
        ...formManage,
        isRequestOtp: false,
        emailVerified: false,
        mobileVerified: false,
      },
      formData: { ...formData, mobileOTP: "", emailOTP: "" },
      mobileResendTime: 0,
      emailResendTime: 0,
    }));
  };

  // renderProductImage = (product, isMobile, desktopStyle, mobileStyle) => {
  //   const map = {
  //     onestock: {
  //       desktop: "/svgs/onestock.svg",
  //       mobile: "/svgs/monestock.svg",
  //     },
  //     portfolio: {
  //       desktop: "/svgs/portfolio.svg",
  //       mobile: "/svgs/mportfolio.svg",
  //     },
  //     protect: { desktop: "/svgs/protect.svg", mobile: "/svgs/mprotect.svg" },
  //     prime: { desktop: "/svgs/prime.svg", mobile: "/svgs/mprime.svg" },
  //     sentiment: {
  //       desktop: "/svgs/Sentiment-signup.svg",
  //       mobile: "/svgs/msentiment-signup.svg",
  //     },
  //   };

  //   const paths = map[product];
  //   if (!paths) {
  //     return (
  //       <Image
  //         src={isMobile ? "/svgs/Signupmobile.svg" : "/svgs/signup1.png"}
  //         objectFit="contain"
  //         rootStyle={isMobile ? mobileStyle : desktopStyle}
  //         imgStyle={{ width: "100%", height: isMobile ? "100%" : "100%" }}
  //       />
  //     );
  //   }

  //   return (
  //     <Image
  //       src={isMobile ? paths.mobile : paths.desktop}
  //       objectFit="contain"
  //       rootStyle={isMobile ? mobileStyle : desktopStyle}
  //       imgStyle={{ width: "100%", height: isMobile ? "auto" : "100%" }}
  //     />
  //   );
  // };

  renderProductImage = (product, isMobile, desktopStyle, mobileStyle) => {
    const map = {
      onestock: {
        desktop: "/svgs/onestock1.svg",
        mobile: "/svgs/monestock.svg",
      },
      portfolio: {
        desktop: "/svgs/portfolio1.svg",
        mobile: "/svgs/mportfolio.svg",
      },
      protect: {
        desktop: "/svgs/protect1.svg",
        mobile: "/svgs/mprotect.svg",
      },
      prime: {
        desktop: "/svgs/prime.svg",
        mobile: "/svgs/mprime1.png",
      },
      sentiment: {
        desktop: "/svgs/Sentiment-signup.svg",
        mobile: "/svgs/msentiment-signup.png",
      },
    };

    const paths = map[product];

    const src = paths
      ? isMobile
        ? paths.mobile
        : paths.desktop
      : isMobile
        ? "/svgs/Signupmobile1.png"
        : "/svgs/signup1.png";

    return (
      <Image
        src={src}
        objectFit="contain"
        rootStyle={{
          height: "100%",
          width: "100%",
          display: "flex",
          // alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          ...(isMobile ? mobileStyle : desktopStyle),
        }}
        imgStyle={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "cover",
        }}
      />
    );
  };

  render() {
    const queryParams = new URLSearchParams(window.location.search);
    const allInOneParams = parseAllInOneSignupParams();
    const product = allInOneParams.isAllInOne
      ? allInOneParams.product
      : queryParams.get("product");
    const useNewAside =
      !product ||
      allInOneParams.isAllInOne ||
      product === "ALL-IN-ONE" ||
      product === "all-in-one" ||
      product === "allInOne";
    const commonImageStyle = { width: "100%", height: "auto" };
    const mobileImageStyle = { height: "26.25rem", width: "100%" };
    const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

    return (
      <Grid
        container
        style={{
          width: "100%",
          height: isMobile ? "auto" : "100vh",
          minHeight: "100vh",
          overflow: isMobile ? "visible" : "hidden",
        }}
      >
        <Grid
          item
          md={6}
          lg={6}
          styles={{ height: "100%" }}
          sx={{ display: { xs: "none", md: "block" }, paddingTop: 0 }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            {useNewAside ? (
              <SignUpAsidePanel />
            ) : (
              this.renderProductImage(product, false)
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={6} lg={6} sx={{ flex: 1 }}>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {useNewAside ? (
              <SignUpAsidePanel compact />
            ) : (
              this.renderProductImage(
                product,
                true,
                commonImageStyle,
                mobileImageStyle,
              )
            )}
          </Box>
          <Box
            sx={{
              minHeight: { xs: "auto", md: "100vh" },
              py: { xs: 0, md: 4 },
              pb: { xs: 5, md: 4 },
              display: "flex",
              justifyContent: "center",
              alignItems: { xs: "flex-start", md: "center" },
              flexDirection: "column",
              bgcolor: "#fff",
            }}
          >
            <SignUpForm
              onChange={this.handleInputChange}
              onSubmit={this.handleFormSubmit}
              onRequestOtp={this.handleRequestOtp}
              onResendOtp={this.handleResendOtp}
              onBackToStep1={this.handleBackToStep1}
              formData={this.state.formData}
              formError={this.state.formError}
              formManage={this.state.formManage}
              emailResendTime={this.state.emailResendTime}
              mobileResendTime={this.state.mobileResendTime}
              isLoading={this.state.isLoading}
              loginUrl={getAllInOneLoginUrl()}
              product={product}
            />
          </Box>
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(SignUpContainer);
